export default __webpack_public_path__ + "static/media/paso4.96f185cf.png";